<template>
      <div class="hl-wid ww4 ubox" v-if="false">
        <div class="ub-head mb">
          <h2>Public Profile</h2>
          <span class="ubh-ico user"></span>
        </div>
        <form class="user-form" v-on:submit.prevent="saveProfile">
          <div class="uf-row split4">
            <div>
              <div class="uf-row">
                <label>Public Name<em>*</em></label>
                <input type="text" v-model="userProfile.pubname" />
              </div>
              <div class="uf-row">
                <label>Level<em>*</em></label>
                <ext-select :options="levelOpt" v-model="userProfile.title"></ext-select>
              </div>
              <div class="uf-row" v-if="false">
                <label>Title</label>
                <input type="text" v-model="userProfile.title" />
              </div>
              <div class="uf-row">
              <label>About Me</label>
              <textarea v-model="userProfile.pubdesc" style="height: 150px"></textarea>
              </div>
            </div>
            <div>
              <label>Profile Image</label>
              <div class="pimg-wid">
                <div class="pimg-con">
                  <img v-if="userProfile.media" :src="photoLinkR(userProfile.media, 256, 256, 'Fit')" />
                  <a href="" v-on:click.prevent="selectMedia(null)"></a>
                </div>
                <div class="pimg-note">
                  Click on image to edit your public appereance
                </div>
              </div>
            </div>
            <div>
              <div class="uf-row">
                <label>My Location<em>*</em></label>
                <input type="text" v-model="userProfile.location" />
              </div>
              <div class="uf-row">
                <label>Spoken languages<em></em></label>
                <input type="text" v-model="userProfile.languages" />
              </div>
              <div class="uf-row">
                <label>My Birthday</label>
                <datepicker v-model="userProfile.birthday" />
              </div>
              <div class="uf-row">
                <label class="check">
                  <input type="checkbox" v-model="userProfile.showAge"></input>
                  <i></i>
                  <span>Show my age on profile</a></span>
                </label>
              </div>
              <div></div>
            </div>
            <div>
              <div class="uf-row">
                <label>Years of Pilates Experience</label>
                <ext-select :options="yearsOpt" v-model="userProfile.experience"></ext-select>
              </div>
              <div class="uf-row">
                <label>Trained By</label>
                <input type="text" v-model="userProfile.frequency" />
              </div>
              <div class="uf-row" v-if="false">
                <label class="check">
                  <input type="checkbox" v-model="userProfile.teacher"></input>
                  <i></i>
                  <span>I'm a Teacher</a></span>
                </label>
              </div>
              <div class="uf-row" v-if="false">
                <label class="check">
                  <input type="checkbox" v-model="userProfile.owner"></input>
                  <i></i>
                  <span>I'm a Studio Owner</a></span>
                </label>
              </div>
              <div class="uf-row">
                <label>Website<em></em></label>
                <input type="text" v-model="userProfile.website" />
              </div>
              <div></div>
            </div>
          </div>
          <div class="uf-row split4">
            <div>
              <label>Your Facebook Account<em></em></label>
              <input type="text" v-model="userProfile.linkFacebook" />
            </div>
            <div>
              <label>Your Instagram Account<em></em></label>
              <input type="text" v-model="userProfile.linkInstagram" />
            </div>
            <div>
              <label>Your Twitter Account<em></em></label>
              <input type="text" v-model="userProfile.linkTwitter" />
            </div>
            <div>
              <label>Your LinkedIn Account<em></em></label>
              <input type="text" v-model="userProfile.linkLinkedin" />
            </div>
          </div>
          <h2 v-if="false && userProfile.teacher">Teacher Details</h2>
          <div class="uf-row split4" v-if="false && userProfile.teacher">
            <div class="uf-row">
              <label>Level<em>*</em></label>
              <ext-select :options="levelOpt" v-model="userProfile.title"></ext-select>
            </div>
            <div class="uf-row">
              <label>Name of Your Teacher<em></em></label>
              <input type="text" v-model="userProfile.teacherName" />
            </div>
            <div class="uf-row">
              <label>Your Teacher Studio<em></em></label>
              <input type="text" v-model="userProfile.teacherStudio" />
            </div>
            <div class="uf-row">
              <label>Certification Date<em></em></label>
              <datepicker v-model="userProfile.teacherDate" />
            </div>
          </div>
          
          <h2 v-if="false && userProfile.owner">Studio Details</h2>
          <div v-if="false && userProfile.owner" class="uf-row split4">
            <div class="uf-row">
              <div class="uf-row">
                <label>Studio Name<em>*</em></label>
                <input type="text" v-model="userProfile.studioName" />
              </div>
              <div class="uf-row nomtop">
                <label>Studio Web Address<em></em></label>
                <input type="text" v-model="userProfile.studioWeb" />
              </div>
              <div class="uf-row nomtop">
                <label>Studio Logo<em></em></label>
                <div class="studiop-wid">
                  <div class="studiop-con" v-for="media in userProfile.studioLogo?[userProfile.studioLogo]:null">
                    <img v-if="media" :src="photoLinkR(media, 256, 256, 'Fit')" />
                    <a href="" v-on:click.prevent="userProfile.studioLogo=null">&#x2010;</a>
                  </div>
                  <div class="studiop-add" v-if="!userProfile.studioLogo"> 
                    <a href="" v-on:click.prevent="selectMedia('studioLogo')">+</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="uf-row">
              <label>About Studio<em></em></label>
              <textarea type="text" v-model="userProfile.studioAbout"></textarea>
            </div>
            <div class="uf-row">
              <label>Studio Location<em></em></label>
              <input type="text" v-model="userProfile.studioLocation" />
            </div>
            <div class="uf-row">
              <label>Studio Email<em></em></label>
              <input type="text" v-model="userProfile.studioEmail" />
            </div>
          </div>
          <div v-if="false && userProfile.owner" class="uf-row split2">
            <div class="blank"></div>
            <div class="movedtop">
              <label>Studio Photos<em></em></label>
              <div class="studiop-wid">
                <div class="studiop-con" v-for="(media, mi) in studioMedia">
                  <img v-if="media" :src="photoLinkR(media, 256, 256, 'Fit')" />
                  <a href="" v-on:click.prevent="removeStudioMedia(mi)">&#x2010;</a>
                </div>
                <div class="studiop-add" v-if="studioMedia.length<4"> 
                  <a href="" v-on:click.prevent="selectMedia('studioPhoto'+(studioMedia.length+1))">+</a>
                </div>
              </div>
            </div>
          </div>

          <div class="uf-row split4">
            <div></div><div></div>
            <div class="uf-row to-c" v-if="false">
              <button class="sec">Profile Preview</button>
            </div>
            <div class="uf-row to-c">
              <button class="main">Update</button>
            </div>
          </div>
        </form>
      </div>
</template>
<script>
import api from './api';
import moment from 'moment';
export default {
  props: ["userProfile"],
  data: ()=>({
    freq: null,
    years: null,
    gender: null,
    freqOpt: [
      "Daily", "Twice a week", "Weekly",
    ],
    yearsOpt: [
      "1", "2", "3", "4", "5", "6", "7", "8", "9", "10",
      "11", "12", "13", "14", "15", "16", "17", "18", "19", "20",
      "21", "22", "23", "24", "25", "26", "27", "28", "29", "30",
      "31", "32", "33", "34", "35", "36", "37", "38", "39", "40",
      "41", "42", "43", "44", "45", "46", "47", "48", "49", "50",
      "51", "52", "53", "54", "55", "56", "57", "58", "59", "60",
      "61", "62", "63", "64", "65", "66", "67", "68", "69", "70",
      "71", "72", "73", "74", "75", "76", "77", "78", "79", "80",
    ],
    genderOpt: [
      "Male", "Female", 
    ],
    levelOpt: [
      "Lolita’s Legacy Educator", "Lolita’s Disciple", "Lolita’s Legacy Graduate", "Lolita’s Legacy Student", "Elder Master Teacher",
//       "Basic Teacher", "Advanced Teacher", "Master Teacher", 
    ],
  }),
  computed: {
    studioMedia() {
      var result=[];
      for(var i=1;i<5;i++) {
        if (this.userProfile["studioPhoto"+i])
          result.push(this.userProfile["studioPhoto"+i]);
      }
      return result;
    },
  },
  methods: {
    formatDate(date, format) {
      if (!date)
        return "";
      return moment(date).format(format);
    },
    formatRelDate(amount, unit, format) {
      return moment().add(amount, unit).format(format);
    },
    selectMedia(field) {
      var f=document.createElement("input");
      f.type="file";
      $(f).on("change", ()=>{
        if (f.files && f.files[0]) {
          this.uploadMedia(f.files[0], field);
        }
      });
      $(f).click();
    },
    async uploadMedia(file, field) {
      var result=await api.create("Media", {store: 1});
      if (result.id) {
        await api.upload("Media", result.id, file);
      }
      var media=(await api.get("Media", result.id)).item;
      this.$set(this.userProfile, field || "media", media);
    },
    removeStudioMedia(index) {
      for(var i=index+1;i<5;i++)
        this.$set(this.userProfile, "studioPhoto"+i, this.userProfile["studioPhoto"+(i+1)]);
    },
    photoLink(media) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return media.store.rootUrl+media.path;
    },
    photoLinkR(media, width, height, mode) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return '/api/Media/'+media.id+'/resize?w='+width+"&h="+height+"&m="+mode;
    },
    async saveProfile() {
      var profile=JSON.parse(JSON.stringify(this.userProfile));
      delete profile.password;
      profile.media=profile.media && profile.media.id;
      profile.studioPhoto1=profile.studioPhoto1 && profile.studioPhoto1.id;
      profile.studioPhoto2=profile.studioPhoto2 && profile.studioPhoto2.id;
      profile.studioPhoto3=profile.studioPhoto3 && profile.studioPhoto3.id;
      profile.studioPhoto4=profile.studioPhoto4 && profile.studioPhoto4.id;
      await api.update("User", this.userProfile.id, profile);
      appNotifications.show("Profile updated", "success");
//       this.$parent.tab="dashboard";
    },
  },
}
</script>
